import { CreateRouteRequest, RouteResponse } from '../../types';
import { logWithAmplitude, post } from './api';

export async function getRoute(amplitude_callsite: string, getRouteRequest: CreateRouteRequest) {
    const response = await fetch(`/api/points/compute_route`, post(getRouteRequest));
    if (!response.ok) {
        throw new Error('An error occurred while creating the route.');
    }

    logWithAmplitude(amplitude_callsite, `Route Requested`, {
        origin: getRouteRequest.origin,
        destination: getRouteRequest.destination,
        num_waypoint: getRouteRequest.intermediates.length,
        mode: getRouteRequest.travel_mode,
    });

    return (await response.json()) as RouteResponse;
}

/// HELPERS

export const maneuver_icon_mapping: Record<string, string> = {
    'TURN_SLIGHT_LEFT': 'turn_slight_left',
    'TURN_SHARP_LEFT': 'turn_sharp_left',
    'UTURN_LEFT': 'u_turn_left',
    'TURN_LEFT': 'turn_left',
    'TURN_SLIGHT_RIGHT': 'turn_slight_right',
    'TURN_SHARP_RIGHT': 'turn_sharp_right',
    'UTURN_RIGHT': 'u_turn_right',
    'TURN_RIGHT': 'turn_right',
    'STRAIGHT': 'arrow_upward',
    'RAMP_LEFT': 'turn_slight_left',
    'RAMP_RIGHT': 'turn_slight_right',
    'MERGE': 'merge',
    'FORK_LEFT': 'fork_left',
    'FORK_RIGHT': 'fork_right',
    'FERRY': 'directions_boat',
    'FERRY_TRAIN': 'boat_railway',
    'ROUNDABOUT_LEFT': 'roundabout_left',
    'ROUNDABOUT_RIGHT': 'roundabout_right',
    'DEPART': 'trip_origin',
    'NAME_CHANGE': 'arrow_upward'
};